// ======================================================================
// File Name       : UploadProgressBar
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { MODAL_SIZE } from '../constants';

class UploadProgressBar extends Component {
  render() {
    const {
      onCancel,
      showModal,
      percentage,
    } = this.props;
    return (
      <Modal
        className="modal-container"
        show={showModal}
        size={MODAL_SIZE.lg}
        dialogClassName="video-upload-progress-dialog"
      >
        <Modal.Header closeButton onHide={onCancel}>
        </Modal.Header>
        <Modal.Body >
          <p className="text-center modal-title">アップロード中です。</p>
          <p className="text-center modal-title margin-bottom-20">※アップロードが完了するまで、ブラウザを閉じないでください</p>
          <div className="progress">
            <div
              className="progress-bar progress-bar-info progress-bar-striped"
              role="progressbar"
              aria-valuenow="0"
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ width: `${percentage}%` }}
            >
              <span>{percentage}%</span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-primary" onClick={onCancel}>キャンセル</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default UploadProgressBar;
